import NBAEntity from '../entities/nba/NBAEntity';
import NBAInsightEntity from '../entities/nba/NBAInsightEntity';
import NBASettingsEntity from '../entities/nba/NBASettingsEntity';
import NBAFileEntity from '../entities/nba/NBAFileEntity';
import _ from 'lodash';
class NBAParser {
  getNBAContainer(nbaContainer) {
    const entity = new NBAEntity();
    _.forEach(nbaContainer.containers, (item, index1) => {
      const insightList = [];
      _.forEach(item.insights, (insightItem, index2) => {
        const insight = new NBAInsightEntity();
        insight.id = insightItem.id;
        insight.offerId = insightItem.offer_id;
        if (_.has(insightItem, 'actions') && insightItem.actions.length !== 0) {
          const insightActionUrls = [];
          insight.isAction = true;
          _.forEach(insightItem.actions, (actions, index3) => {
            const actionObj = {
              url: _.has(actions, 'url') ? actions.url : null,
              label: _.has(actions, 'label') ? actions.label : null,
            };
            insightActionUrls.push(actionObj);
          });
          insight.actionUrl = insightActionUrls;
        } else {
          insight.isAction = false;
        }
        if (
          _.has(insightItem, 'text_content') &&
          !_.isEmpty(insightItem.text_content)
        ) {
          insight.isTextContent = true;
          insight.textHeader = insightItem.text_content.header;
          insight.textValue = insightItem.text_content.text;
          insight.textInstruction = insightItem.text_content.instruction;
          insight.textStaticUrl = insightItem.text_content.static_url;
          insight.icon = insightItem.text_content.icon;
        } else {
          insight.isTextContent = false;
        }
        if (
          _.has(insightItem, 'image_content') &&
          !_.isEmpty(insightItem.image_content)
        ) {
          insight.isImageContent = true;
          insight.imageUrl = insightItem.image_content.image_url;
          insight.imageAltText = insightItem.image_content.alt_text;
        } else {
          insight.isImageContent = false;
        }
        insight.containerId = item.id;
        insightList.push(insight);
      });
      entity.addItem(item.id, insightList);
    });
    return entity;
  }
  getNBASettings(settingsResponse) {
    const settings = new NBASettingsEntity();
    settings.setInsightEnable(settingsResponse.insights_enabled);
    settings.setSplashEnabled(settingsResponse.splash_enabled);
    settings.setSplashId(settingsResponse.splash_id);
    settings.setSplashAcknowledged(settingsResponse.splash_acknowledged);
    return settings;
  }
  getJSONFileObject(fileResponse) {
    const fileData = new NBAFileEntity();
    if (fileResponse.text_content) {
      const textObj = fileResponse.text_content;
      fileData.textHeader = textObj.header;
      fileData.textSubHeader = textObj.sub_header;
      fileData.textValueParts = [];
      if (textObj.text && textObj.text.text_parts) {
        _.forEach(textObj.text.text_parts, (part, id) => {
          fileData.textValueParts.push(part);
        });
      }
      fileData.textInstruction = textObj.instruction;
      fileData.textTnC = textObj.terms_conditions;
    }
    return fileData;
  }
  getHtmlFileObject(fileResponse) {
    const fileData = new NBAFileEntity();
    const doc = document.implementation.createHTMLDocument('nba');
    doc.documentElement.innerHTML = fileResponse;
    const header = doc.getElementsByTagName('h1');
    const subHeader = doc.getElementsByTagName('h2');
    const paragraphs = doc.getElementsByTagName('p');
    fileData.textHeader = header.length > 0 ? header[0].innerHTML : '';
    fileData.textSubHeader = subHeader.length > 0 ? subHeader[0].innerHTML : '';
    fileData.textValueParts = [];
    if (paragraphs.length > 0) {
      _.forEach(paragraphs, (para, id) => {
        fileData.textValueParts.push(para.innerHTML);
      });
    }
    fileData.textTnC = fileData.textValueParts.pop();
    return fileData;
  }
}

export default new NBAParser();
